import type { UsedSource } from "@noa/api-core";
import { AuthenticatedImage } from "./chat-message-authenticated-image";

const SOURCE_ONLY_IMAGE_GALLERY_STYLE = { display: "flex", flexWrap: "wrap" as const, gap: 8, marginTop: 8 };

interface ChatMessageImageGalleryProps {
  authenticatedImages: UsedSource[];
  isStreaming: boolean;
}

export function ChatMessageImageGallery({ authenticatedImages, isStreaming }: ChatMessageImageGalleryProps) {
  if (isStreaming || authenticatedImages.length === 0) return null;

  return (
    <div style={SOURCE_ONLY_IMAGE_GALLERY_STYLE}>
      {authenticatedImages.map((source) => (
        <AuthenticatedImage
          key={source.unique}
          url={source.image_url!}
          alt={`${source.source_document_name} - ${source.location_information}`}
        />
      ))}
    </div>
  );
}
